const SAMAN_CONFIG = {
    api: "/",
    enableSSO: false,
    sso: "http://localhost:8000/openid/",
    ssoClientID: "803673",
    ssoScopes: "openid profile",
    accessTokenExpiringNotificationTime: 10,
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
    versionDetails:
    "Saman-MFA is a universal multi-factor authentication solution for your organization. It can add multi-factor authentication to many Operating Systems, network devices, and web applications, including Windows, Linux, Cisco devices, Fortinet devices, etc. Do not hesitate to contact us if you have any questions.\n" +
    "<br>All rights are reserved for PayamPardaz, Iran Cyber Security Company."
};

export default SAMAN_CONFIG;
